module.exports = __webpack_public_path__ + "static/media/microscope.a221518a.jpg";